import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const LineChartWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function LineChartWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.06383 1C2.65137 1 3.12766 1.47629 3.12766 2.06383V28.8723H29.9362C30.5237 28.8723 31 29.3486 31 29.9362C31 30.5237 30.5237 31 29.9362 31H2.2766C1.57156 31 1 30.4285 1 29.7234V2.06383C1 1.47629 1.47629 1 2.06383 1Z"
        fill="#5137A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.6596 9.68898C30.2021 9.91451 30.4591 10.5372 30.2336 11.0797L29.2513 10.6713C30.2336 11.0797 30.2336 11.0797 30.2336 11.0797L30.2322 11.0831L30.2293 11.0898L30.2196 11.1129L30.1838 11.1963C30.1528 11.2678 30.1075 11.3706 30.0488 11.4999C29.9315 11.7584 29.76 12.1237 29.5401 12.5585C29.102 13.4248 28.4646 14.5813 27.6743 15.7197C26.8905 16.8488 25.9205 18.0125 24.8039 18.8475C23.686 19.6833 22.3103 20.2677 20.7877 19.9929C18.699 19.6159 17.8215 17.8756 17.2167 16.6761C17.1959 16.6348 17.1754 16.5941 17.1552 16.5541C16.4513 15.1635 16.0047 14.4219 15.0431 14.2484C14.3172 14.1173 13.5342 14.3644 12.6789 15.0039C11.8225 15.6444 11.0048 16.6001 10.2822 17.6411C9.56593 18.6728 8.97792 19.7371 8.56724 20.5492C8.3627 20.9536 8.20402 21.2917 8.09721 21.527C8.04384 21.6446 8.00352 21.7362 7.97701 21.7974L7.94772 21.8656L7.94104 21.8814L7.93976 21.8845C7.71411 22.4268 7.09147 22.6839 6.54906 22.4584C6.00654 22.2329 5.74957 21.6103 5.9751 21.0677L6.95743 21.4761C5.9751 21.0677 5.9751 21.0677 5.9751 21.0677L5.97652 21.0643L5.97933 21.0576L5.98909 21.0345L6.02489 20.9511C6.05591 20.8796 6.10114 20.7768 6.15984 20.6475C6.27717 20.3891 6.44873 20.0237 6.66858 19.5889C7.1067 18.7227 7.7441 17.5661 8.53437 16.4277C9.31823 15.2986 10.2881 14.1349 11.4048 13.3C12.5226 12.4641 13.8983 11.8797 15.421 12.1545C17.5097 12.5315 18.3872 14.2719 18.9919 15.4713C19.0128 15.5127 19.0333 15.5533 19.0535 15.5933C19.7574 16.9839 20.204 17.7255 21.1655 17.899C21.8915 18.0301 22.6745 17.783 23.5297 17.1435C24.3862 16.5031 25.2039 15.5473 25.9265 14.5063C26.6427 13.4746 27.2308 12.4103 27.6414 11.5982C27.846 11.1938 28.0047 10.8557 28.1115 10.6204C28.1648 10.5028 28.2052 10.4112 28.2317 10.35L28.261 10.2818L28.2676 10.266L28.2689 10.2629C28.4946 9.72064 29.1172 9.46349 29.6596 9.68898Z"
        fill="#EF145D"
      />
    </SvgStyled>
  );
});
